import { useState } from "react";
import api from "@/lib/api";

export default function ChangePassword() {
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [err, setErr] = useState("");
    const [ok, setOk] = useState(false);
    const [saving, setSaving] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setOk(false);
        if (next.length < 6) return setErr("New password must be at least 6 characters.");
        if (next !== confirm) return setErr("New passwords don't match.");
        setSaving(true);
        try {
            await api.post("/auth/change-password", { current_password: current, new_password: next });
            setOk(true);
            setCurrent(""); setNext(""); setConfirm("");
        } catch (e2) {
            const d = e2?.response?.data?.detail;
            setErr(typeof d === "string" ? d : "Couldn't update password. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <form onSubmit={submit} data-testid="change-password-form" style={{ maxWidth: 480 }}>
            <p style={{ fontFamily: "var(--font-serif)", color: "var(--cocoa)", opacity: 0.8, marginBottom: 20 }}>
                Rotate your password whenever you like. You&apos;ll stay signed in on this device.
            </p>

            {err && <div className="form-error" style={{ marginBottom: 16 }} data-testid="change-password-error">{err}</div>}
            {ok && (
                <div data-testid="change-password-success" style={{
                    padding: "12px 16px", background: "var(--cocoa)", color: "var(--ivory)",
                    marginBottom: 16, fontFamily: "var(--font-serif)", fontStyle: "italic",
                }}>
                    ✓ Password updated.
                </div>
            )}

            <div className="field">
                <label className="label">Current password</label>
                <input
                    className="input" type="password" required
                    value={current} onChange={(e) => setCurrent(e.target.value)}
                    data-testid="change-password-current" autoComplete="current-password"
                />
            </div>
            <div className="field">
                <label className="label">New password (min. 6 characters)</label>
                <input
                    className="input" type="password" required minLength={6}
                    value={next} onChange={(e) => setNext(e.target.value)}
                    data-testid="change-password-new" autoComplete="new-password"
                />
            </div>
            <div className="field">
                <label className="label">Confirm new password</label>
                <input
                    className="input" type="password" required minLength={6}
                    value={confirm} onChange={(e) => setConfirm(e.target.value)}
                    data-testid="change-password-confirm" autoComplete="new-password"
                />
            </div>
            <button className="btn" type="submit" disabled={saving} data-testid="change-password-submit">
                {saving ? "Updating…" : "Update password"}
            </button>
        </form>
    );
}
